import { render, staticRenderFns } from "./AnnouncementTime.vue?vue&type=template&id=d837c924&scoped=true"
import script from "./AnnouncementTime.vue?vue&type=script&lang=js"
export * from "./AnnouncementTime.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTime.vue?vue&type=style&index=0&id=d837c924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d837c924",
  null
  
)

export default component.exports